/**
 * @ngdoc Directive
 * @name vrmStateWidget
 * @example
 *
 * <vrmStateWidget installation="installation" type="BatteryGraph" />
 *
 */

import {mixinZoomState} from '@/angular/modules/vrm-components/graph-widget/zoomstate';

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmStateWidget', vrmStateWidget)
        .constant('AdvancedStateWidgetConfigs', {
            'VeBusWarningsAndAlarms': [{
                reversed: true,
                fields: {
                    'eT': null,
                    'eT1': null,
                    'eT2': null,
                    'eT3': null,
                    'eL': null,
                    'eL1': null,
                    'eL2': null,
                    'eL3': null,
                    'eO': null,
                    'eO1': null,
                    'eO2': null,
                    'eO3': null,
                    'ePR': null,
                    'eR': null,
                },
                showOnlyWithData: true,
                ignore: [0]
            }],
            'BatteryMonitorWarningsAndAlarms': [{
                reversed: true,
                fields: {
                    'AL': null,
                    'AH': null,
                    'ALS': null,
                    'AHS': null,
                    'ASoc': null,
                    'ALT': null,
                    'AHT': null,
                    'AM': null,
                    'ALF': null,
                    'AHF': null,
                    'AFB': null,
                    'AHIT': null,
                    'ACI': null,
                    'AHC': null,
                    'AHD': null,
                    'AHCT': null,
                    'ALCT': null,
                    'AIE': null,
                    'ALCV': null,
                    'Abc': null,
                    'Abd': null
                },
                showOnlyWithData: true,
                ignore: [0]
            }],
            'MPPTState': [{
                fields: {
                    'ScS': null
                }
            }],
            'GeneratorState': [{
                fields: {
                    'gaRC': null
                }
            }],
            'InverterState': [{
                fields: {
                    'iST': null
                }
            }],
            'InputState': [{
                fields: {
                    'dis': null
                }
            }],
            'ChargerState': [{
                fields: {
                    'cSt': null
                }
            }],
            'VeBusState': [{
                fields: {
                    'S': null
                }
            }],
            'BatteryRelayState': [{
                fields: {
                    'Relay': null
                }
            }],
            'BatteryExternalRelayState': [{
                fields: {
                    'eRelay': null
                }
            }],
            'ChargerRelayState': [{
                fields: {
                    'cR': null
                }
            }],
            'GatewayRelayState': [{
                fields: {
                    'cRelay': null
                }
            }],
            'GatewayRelayTwoState': [{
                fields: {
                    'cRelay1': null
                }
            }],
            'SolarChargerRelayState': [{
                fields: {
                    'SRelay': null
                }
            }],
            'FuelCellState': [{
                fields: {
                    'fcS': null
                }
            }],
            'EssBatteryLifeState': [{
                fields: {
                    'H4bs': null
                }
            }],
            'InverterChargerRelayState': [{
                fields: {
                    'mRelay': null
                }
            }],
            'InverterChargerState': [{
                fields: {
                    'mSa': null
                }
            }],
            'InverterChargerWarningsAndAlarms': [{
                reversed: true,
                fields: {
                    'meT': null,
                    'meHV': null,
                    'meHVO': null,
                    'meLT': null,
                    'meLV': null,
                    'meLVO': null,
                    'emO': null,
                    'emR': null,
                },
                showOnlyWithData: true,
                ignore: [0]
            }],
            'InverterRSSolarRelayState': [{
                fields: {
                    'iRelay': null
                }
            }],
            'InverterRSSolarWarningsAndAlarms': [{
                reversed: true,
                fields: {
                    'iHT': null,
                    'iHV': null,
                    'iHVA': null,
                    'iLT': null,
                    'iLV': null,
                    'iLVA': null,
                    'iO': null,
                    'iR': null,
                    'iS': null
                },
                showOnlyWithData: true,
                ignore: [0]
            }],
            'DcDcConverterState': [{
                fields: {
                    'DcS': null
                }
            }],
            'SmartBatteryProtectState': [{
                fields: {
                    'bPS': null
                }
            }],
            'SmartLithiumBalancerState': [{
                fields: {
                    'sLBS': null
                }
            }],
            'AlternatorState': [{
                fields: {
                    'als': null
                }
            }],
        });

    /* @ngInject */
    function vrmStateWidget() {

        return {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/state-widget/state-widget.template.html'),
            controller: controller,
            scope: {
                iconClass: '=',
                customName: '=',
                installation: '=',
                type: '=',
                instance: '=',
                title: '=',
                subTitle: '=',
                tooltip: '=',
                range: '=',
                zoomstate: '=',
                widgetId: '=',
                isMobile: '=',
                hasTouchEnabled: '=',
                size: '=',
                itemState: '=?'
            }
        };

        /* @ngInject */
        function controller($scope, $q, ApiService, GraphService, AdvancedStateWidgetConfigs, vrmConfig, reversedStateGraph, stateGraph) {
            let loaded = false;
            $scope.inview = false;
            $scope.showChart = vrmConfig.autoLoadStateWidgets;
            $scope.setWatcher = true;

            $scope.$watch('type', function() {
                $scope.meta = AdvancedStateWidgetConfigs[$scope.type];
                $scope.current = $scope.meta[0];
            });

            $scope.$watch('size', () => {
                if (!$scope.chart || !$scope.chart.getHighcharts) return;
                $scope.chart.getHighcharts().reflow();
            });

            $scope.setCurrent = function(meta) {
                $scope.current = meta;
            };

            $scope.clickExpand = () => {
                if ($scope.itemState) $scope.itemState.expanded = !$scope.itemState.expanded;
            }

            $scope.$watch('showChart', () => {
                if($scope.showChart) {
                    // Only do a data load every 300 ms, to prevent multiple loads
                    let dataLoadTimeout = null;
                    $q.all([GraphService.ready()]).then(function() {
                        function load() {
                            // Only load data if tab is active in browser and widget in view
                            if ((typeof document.hidden != 'undefined' && document.hidden) || loaded || !$scope.inview) return;
                            clearTimeout(dataLoadTimeout);
                            dataLoadTimeout = setTimeout(() => {
                                //Never change initial loaded chart
                                if (!$scope.chart) {
                                    $scope.chart = $scope.current.reversed ? reversedStateGraph() : stateGraph();
                                }
                                loaded = true;
                                mixinZoomState($scope, $scope.setWatcher, 'yAxis');
                                $scope.setWatcher = false;

                                if ($scope.installation != null) {
                                    var url = 'widgets/' + $scope.type + "?start=" + $scope.range.startDate + "&end=" + $scope.range.endDate;
                                    if ($scope.instance) {
                                        url += '&instance=' + $scope.instance;
                                    }

                                    $scope.chart.loading = true;
                                    ApiService.installations($scope.installation.id, url).then(function(response) {
                                        $scope.data = response.data;
                                        $scope.chart.loading = false;
                                        $scope.chart.yAxis.crosshair = {width: 1};
                                        if ($scope.current.reversed) {
                                            GraphService.updateReversedStateConfig($scope.chart, response.data.records, $scope.range, $scope.current.fields, $scope.current.ignore, $scope.current.showOnlyWithData);
                                        } else {
                                            GraphService.updateStateConfig($scope.chart, response.data.records, $scope.range, $scope.current.fields);
                                        }
                                    });
                                }
                            }, 300);
                        }

                        $scope.$watchGroup(['range.startDate', 'range.endDate', 'current'], function() {
                            loaded = false;
                            load();
                        });

                        $scope.$watchGroup(['installation', 'inview'], function() {
                            load();
                        });

                        $scope.$on('$destroy', () => {
                            clearTimeout(dataLoadTimeout);
                        });
                    });
                }
            })
        }
    }
})();
